import React, { useState } from 'react';
import { MOCK_VENDORS } from './mockData';
import VendorStats from './components/VendorStats';
import VendorToolbar from './components/VendorToolbar';
import VendorList from './components/VendorList';
import DeleteVendorModal from './components/DeleteVendorModal';
import VendorModal from './components/VendorModal';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import 'jquery';
import './styles/VendorManagementPage.css';
import { useVendorManagement } from './hooks/useVendorManagement';
import LoadMask from '../../Utils/LoadMask';
import { useVendorUpdates } from './hooks/useVendorUpdates';

export const VendorManagementPage = () => {
   const {
      vendorStats,
      filteredVendors,

      vendorFilters,
      setVendorFilters,

      GetVendors,
      RefreshData,

      fetchingStats,
      fetchingVendors,

      pagination,
   } = useVendorManagement();

   const {
      showVendorModal,
      setShowVendorModal,
      showDeleteModal,
      setShowDeleteModal,

      selectedVendor,
      setSelectedVendor,

      AddNewVendor,
      DeleteVendor,
      UpdateVendor,

      updatingData,
   } = useVendorUpdates(RefreshData);

   const toggleVendorModal = (vendor, show) => {
      setSelectedVendor(vendor);
      setShowVendorModal(show);
   };

   const toggleDeleteModal = (vendor, show) => {
      setSelectedVendor(vendor);
      setShowDeleteModal(show);
   };

   return (
      <LoadMask loading={fetchingStats} blur>
         <div className="vendors-root">
            <main className="vendors__main-content">
               <div className="d-flex align-items-center justify-content-between mb-4">
                  <h1 className="vendors__page-title">Vendor Management</h1>
               </div>

               <VendorStats vendorStats={vendorStats} />

               <LoadMask loading={fetchingVendors && !fetchingStats} blur>
                  <VendorToolbar
                     vendorFilters={vendorFilters}
                     setVendorFilters={setVendorFilters}
                     openAddVendor={() => toggleVendorModal(null, true)}
                     refetchData={RefreshData}
                     isRefetching={fetchingVendors}
                  />

                  <VendorList
                     vendors={filteredVendors}
                     pagination={pagination}
                     onPageChange={(page) => GetVendors(page, pagination.pageSize, vendorFilters)}
                     openEditVendor={(vendor) => toggleVendorModal(vendor, true)}
                     openDeleteVendor={(vendor) => toggleDeleteModal(vendor, true)}
                  />
               </LoadMask>
            </main>

            {showVendorModal && (
               <VendorModal
                  vendor={selectedVendor}
                  onClose={() => toggleVendorModal(null, false)}
                  onSave={selectedVendor ? UpdateVendor : AddNewVendor}
                  loading={updatingData}
               />
            )}

            {showDeleteModal && (
               <DeleteVendorModal
                  vendor={selectedVendor}
                  onClose={() => toggleDeleteModal(null, false)}
                  onConfirm={() => DeleteVendor(selectedVendor.id)}
                  loading={updatingData}
               />
            )}
         </div>
      </LoadMask>
   );
};
